import { Box, CircularProgress, useTheme } from '@mui/material';

import { useDotCount } from './useDotCount';

export const DotCountMessage = () => {
  const { dotCount } = useDotCount();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <CircularProgress size={20} sx={{ marginRight: theme.spacing(2) }} />

      <span className="loading-dots">
        Processing
        {Array(dotCount)
          .fill('.')
          .map((dot, index) => (
            <span key={index} className="dot">
              {dot}
            </span>
          ))}
      </span>
    </Box>
  );
};
